export default "__VITE_ASSET__a71c5a66__"